import { DeviceStatusCheck } from 'app/agriculture/routes/Devices/utils/status/types';

export const checkTankSensor: DeviceStatusCheck<['Level']> = ({ device, snapshots }) => {
    if (device.deviceType !== 'Level Monitor') return { messages: [], status: 'success' };

    if (device.infrastructureId == null) {
        return { messages: ['Sensor device not linked with a tank'], status: 'warning' };
    }

    if (!snapshots.Level) {
        return { messages: ['No tank sensor data'], status: 'warning' };
    }

    return { messages: [], status: 'success' };
};
